// import { USER_LOGGED_IN, USER_LOGGED_OUT } from '../actions/';

const INITIAL_STATE = null;

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "USER_LOGGED_IN":
      return action.payload;
    case "USER_LOGGED_OUT":
      return null;
    case "USER_UPDATED":
      return { ...state, user: action.payload };
    case "UPDATE_TOKENS":
      return {
        ...state,
        user: {
          ...state.user,
          token: action.payload.accessToken,
          refresh_token: action.payload.refreshToken
        }
      };
    default:
      return state;
  }
};
